import { themeQuartz } from 'ag-grid-community';

export const denseTheme = themeQuartz.withParams({
  spacing: 2,
  headerFontSize: 13,
  fontSize: 13,
  rowVerticalPaddingScale: 2,
  headerVerticalPaddingScale: 3
});
